import { rgb } from 'pdf-lib'

/** x方向寄せ定数 */
export const [X_ALIGN_LEFT, X_ALIGN_CENTER, X_ALIGN_RIGHT] = [0,1,2];
/** y方向寄せ定数 */
export const [Y_ALIGN_TOP, Y_ALIGN_CENTER, Y_ALIGN_BOTTOM] = [0,1,2];

/** drawTextInBoxデフォルト設定 */
const DRAW_TEXT_IN_BOX_DEFAULT_OPTION = {
  size: 10,
  shrink: true,
  lineBreaking: false,
  xAlign: X_ALIGN_LEFT,
  yAlign: X_ALIGN_CENTER,
  xPadding: 2,
  yPadding: 2,
  color: rgb(0,0,0)
}

/**
 * 指定されたboxに文字を出力する
 * boxの指定は{x1, x2, y1, y2}
 * optionの指定は{font, size, shrink, line, xAlign, yAlign, xPadding, yPadding, color}
 */
export const drawTextInBox = (page, text, box, option) => {
  if (!text) {
    return;
  }
 
  const newOption = {...DRAW_TEXT_IN_BOX_DEFAULT_OPTION, ...option};

  let capableBox = getCapableBox(box, newOption);

  let textInfo = getTextInfo(text, newOption);
  let textLineInfoArray = getTextLineInfoArray(textInfo, capableBox, newOption);

  drawEachLine(page, textLineInfoArray, capableBox);
}

/**
 * 文字の入るx, yの範囲を取得
 */
const getCapableBox = (box, option) => {
  let {x1, x2, y1, y2} = box;
  let {xPadding, yPadding} = option;

  let capableStartX = Math.min(x1, x2) + xPadding;
  let capableEndX = Math.max(x1, x2) - xPadding;
  let capableStartY = Math.max(y1, y2) - yPadding;
  let capableEndY = Math.min(y1, y2) + yPadding;

  let capableWidth = Math.max(capableEndX - capableStartX, 0);
  let capableHeight = Math.max(capableStartY - capableEndY, 0);
  
  return {capableStartX, capableEndX, capableStartY, capableEndY, capableWidth, capableHeight};
}

/**
 * 描画するテキスト全体に関する情報を取得
 */
const getTextInfo = (text, option) => {
  let charArray = text.split('');
  let widthOfChars = Array.from(charArray).map((charStr) => option.font.widthOfTextAtSize(charStr, option.size));
  let widthOfWholeText = Array.from(widthOfChars).reduce((prevWidth, thisWidth) => prevWidth + thisWidth, 0);
  return {text, charArray, widthOfChars, widthOfWholeText};    
}

/**
 * 文字サイズの縮小率を取得
 */
const getShrinkRate = (textInfo, capableWidth, capableHeight, option) => {
  let {shrink, lineBreaking, size} = option;
  let {widthOfWholeText} = textInfo;

  return shrink && !lineBreaking && (capableWidth < widthOfWholeText || capableHeight < size)
    ? Math.min(capableWidth / widthOfWholeText, capableHeight / size, 1)
    : 1;
}

/**
 * 行ごとのテキスト情報を取得
 */
const getTextLineInfoArray = (textInfo, capableBox, option) => {
  let {charArray, widthOfChars, widthOfWholeText} = textInfo;
  let {capableWidth, capableHeight} = capableBox;
  let {size, shrink, lineBreaking} = option;

  if (!lineBreaking) {    
    let shrinkRate = getShrinkRate(textInfo, capableWidth, capableHeight, option);
    return {
      ...option,
      size: size * shrinkRate,
      textLines: [{
        chars: charArray,
        charWidths: widthOfChars.map((w) => w * shrinkRate),
        lineWholeWidth: widthOfWholeText * shrinkRate,
      }]
    };
  }

  let textLines = [];

  let thisLineChars = [];
  let thisLineCharWidths = [];
  let thisLineWidth = 0;

  charArray.forEach((charStr, charIndex) => {
    let charWidth = widthOfChars[charIndex];

    if (thisLineChars.length > 0 && thisLineWidth + charWidth > capableWidth) {
      textLines.push({
        chars: thisLineChars,
        charWidths: thisLineCharWidths,
        lineWholeWidth: thisLineWidth,
      });
      thisLineChars = [charStr];
      thisLineCharWidths = [charWidth];
      thisLineWidth = charWidth;
    } else {
      thisLineChars.push(charStr);
      thisLineCharWidths.push(charWidth);
      thisLineWidth += charWidth; 
    }
  })

  textLines.push({
    chars: thisLineChars,
    charWidths: thisLineCharWidths,
    lineWholeWidth: thisLineWidth,
  });

  return {...option, textLines};
}

/**
 * 行ごとにテキストを出力
 */
const drawEachLine = (page, textLineInfoArray, capableBox) => {
  let {capableStartX, capableEndX, capableStartY, capableEndY} = capableBox;
  let {size, font, color, xAlign, yAlign, textLines} = textLineInfoArray;

  let lineCount = textLines.length;

  let textStartY = [capableStartY - size, (capableStartY + capableEndY + (lineCount - 2) * size) / 2, capableEndY + (lineCount - 1) * size][yAlign];

  textLines.forEach((textLine, lineIndex) => {
    drawTextLine(page, textLine, capableStartX, capableEndX, textStartY - lineIndex * size, {size, font, color, xAlign});
  });
}

/**
 * 1行分を指定位置に描画する
 */
const drawTextLine = (page, textLine, capableStartX, capableEndX, textY, textOption) => {
  let {chars, charWidths, lineWholeWidth} = textLine;
  let {size, font, color, xAlign} = textOption;

  let thisCharX = [capableStartX, (capableStartX + capableEndX - lineWholeWidth) / 2, capableEndX - lineWholeWidth][xAlign];

  Array.from(chars).forEach((charStr, charIndex) => {
    page.drawText(charStr, {
      x: thisCharX, y: textY, size, font, color
    })
    thisCharX += charWidths[charIndex];
  })
}


